import React from 'react';
import { Nav } from 'react-bootstrap';
import styles from '../../../styles/TryNow.module.css';

const UploadTabSelector = ({ activeTab, setActiveTab }) => {
  return (
    <div className="px-2 customTab d-md-flex flex-column justify-content-start align-items-md-center">
      <p className=" font_12 mb-2">Choose Document Side</p>
      <div className="d-flex">
        <Nav
          variant="tabs"
          activeKey={activeTab}
          onSelect={(k) => setActiveTab(k)}
          className={styles.uploadTabs}
        >
          <Nav.Item>
            <Nav.Link eventKey="front">Front</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="back">Back</Nav.Link>
          </Nav.Item>
        </Nav>
      </div>
    </div>
  );
};

export default UploadTabSelector;
